import size from "lodash/size";

import { REQUIRED, IS_EMAIL } from "../../constants/validations";

const validate = (values) => {
  let errors = {};

  if (!values.first_name) {
    errors.first_name = REQUIRED;
  }

  if (!values.last_name) {
    errors.last_name = REQUIRED;
  }

  if (!values.phone_mobile) {
    errors.phone_mobile = REQUIRED;
  } else if (size(values.phone_mobile) < 14) {
    errors.phone_mobile = "Please complete the mobile number";
  }

  const emailAddress = values.email;

  if (!emailAddress) {
    errors.email = REQUIRED;
  } else if (IS_EMAIL.test(emailAddress) === false) {
    errors.email = "Invalid email format";
  }

  if (size(values.area_you_service) === 0) {
    errors.area_you_service = REQUIRED;
  }

  if (!values.appropriate_licensing) {
    errors.appropriate_licensing = REQUIRED;
  }

  if (!values.bridge_financing_per_month) {
    errors.bridge_financing_per_month = REQUIRED;
  }

  if (!values.bridge_financing_per_yr) {
    errors.bridge_financing_per_yr = REQUIRED;
  }

  return errors;
};

export default validate;



// WEBPACK FOOTER //
// ./src/Screens/BrokerQuestion/validations.js